import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, Linkedin, ChevronRight } from 'lucide-react';
import logo from '../assest/PITlogo.svg';

const Footer: React.FC<{ hasSearchBar?: boolean }> = ({ hasSearchBar = true }) => {
  return (
    <footer
      role="contentinfo"
      className={`bg-gray-900 text-gray-300 pt-12 border-t border-gray-700 w-full overflow-hidden ${
        hasSearchBar ? "pb-[100px] sm:pb-[120px]" : "pb-8"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        
        {/* Main Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12 mb-10">
          
          <div className="sm:col-span-2 lg:col-span-2 text-center sm:text-left">
            <div className="mb-4 flex justify-center sm:justify-start">
              <a href="/" aria-label="Project Infotech Home">
                <img src={logo} alt="Project Infotech (PIT) - Premium IT Training & Software Certification Institute" className="h-10 w-auto" />
              </a>
            </div>
            <p className="text-sm leading-relaxed mb-6 text-gray-400">
              India's leading e-learning platform dedicated to Full Stack Development, Data Science, and App Development career growth through expert-led tech courses.
            </p>
            <div className="flex justify-center sm:justify-start space-x-5">
              <a href="#" aria-label="Follow us on Facebook" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-all"><Facebook size={20} aria-hidden="true" /></a>
              <a href="#" aria-label="Follow us on Twitter" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-all"><Twitter size={20} aria-hidden="true" /></a>
              <a href="#" aria-label="Follow us on Instagram" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-all"><Instagram size={20} aria-hidden="true" /></a>
              <a href="#" aria-label="Connect with us on LinkedIn" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-all"><Linkedin size={20} aria-hidden="true" /></a>
            </div>
          </div>
          
          <div className="text-center sm:text-left">
            <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">Quick Links</h4>
            <nav aria-label="Footer Quick Links">
              <ul className="space-y-3 text-sm">
                <li><a href="/" title="Go to Homepage" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> Home</a></li>
                <li><a href="/about" title="Read About Us" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> About Us</a></li>
                <li><a href="/placement" title="View Placement Records" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> Placement</a></li>
              </ul>
            </nav>
          </div>
          
          <div className="text-center sm:text-left">
            <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">Top Courses</h4>
            <nav aria-label="Footer Top Courses">
              <ul className="space-y-3 text-sm">
                <li><a href="/java-full-stack" title="Learn Full Stack Development" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> Full Stack Dev</a></li>
                <li><a href="/data-science" title="Learn Data Science" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> Data Science</a></li>
                <li><a href="/ui-ux-design" title="Learn UI/UX Design" className="hover:text-red-500 flex items-center justify-center sm:justify-start"><ChevronRight size={14} className="mr-1" aria-hidden="true" /> UI/UX Design</a></li>
              </ul>
            </nav>
          </div>

          <div className="text-center sm:text-left">
            <h4 className="text-white font-bold mb-5 uppercase text-sm tracking-wider">Contact Us</h4>
            <address className="not-italic">
              <ul className="space-y-4 text-sm flex flex-col items-center sm:items-start">
                {/* <li className="flex items-start gap-2"><MapPin size={16} className="text-red-600 mt-1" aria-hidden="true" /> 123, Tech Hub, Bangalore</li> */}
                <li className="flex items-center gap-2">
                  <Phone size={16} className="text-red-600" aria-hidden="true" /> 
                  <a href="tel:+917782918158" aria-label="Call us at +91 7782918158" className="hover:text-white transition-colors">+91 7782918158</a>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={16} className="text-red-600" aria-hidden="true" /> 
                  <a href="mailto:projectinfotech.in@gmail.com" aria-label="Email us at projectinfotech.in@gmail.com" className="hover:text-white transition-colors">projectinfotech.in@gmail.com</a>
                </li>
              </ul>
            </address>
          </div>
        </div>
        
        {/* Copyright Section */}
        <div className="pt-8 border-t border-gray-800 text-center flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Project Infotech (PIT) E-Learning. All Rights Reserved.
          </p>
          <div className="flex space-x-6 text-xs text-gray-500">
            <a href="/privacy-policy" className="hover:text-white" rel="nofollow">Privacy Policy</a>
            <a href="/terms" className="hover:text-white" rel="nofollow">Terms of Service</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;